export default {
   triggerNativeEvent: function (el, eventName) {
      if(el.fireEvent)
      {
         // < IE9
         (el.fireEvent('on' + eventName));
      }
      else
      {
         let evt = document.createEvent('Events');
         evt.initEvent(eventName, true, false);
         el.dispatchEvent(evt);
      }
   }
}